import { Component, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';

@Component({
  selector: 'app-addgiver',
  templateUrl: './addgiver.component.html',
  styleUrls: ['./addgiver.component.css']
})
export class AddgiverComponent extends FormSessionCanDeactivate {
  secondArray: any = [];
  public temp_var: boolean = false;
  result: any;
  car: any;
  public data: Object;
  patid: any;
  ffar: string = '';
  giver: any;
  group: any = [];
  ccType: any = {};
  ca: any = {}
  caregive: any;
  selectedDeviceObj: any = "";
  selectedObj: any = "";
  type: any;
  modalRef: any;
  resdata: any;
  patname: any;
  apiurl: any = environment.api_url;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
  }

  constructor(
    private patientservice: PatientService,
    private router: Router,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private userservic: UserService
  ) {
    super();
  }
  public imageURL: string = environment.cloudeImageURL;
  public currentUser: User;

  ngOnInit() {

    this.patid = JSON.parse(atob(window.localStorage['careGiverDetails']))
    this.userservic.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )

    if (this.currentUser.item.hostModel == "CLOUD") {
      this.imageURL = environment.cloudeImageURL;
    } else {
      this.imageURL = environment.vmImageURL;
    }



    //////console.log('id ' + this.patid.patientId);
    //////console.log('SWFid ' + this.patid.patientSWFId);
    //////console.log('SWFid ' + this.patid.statusid);



    this.patientservice
      .getpatientinfo(this.patid.patientId, this.patid.patientSWFId)
      .subscribe(
        data => {

          this.giver = data;
        }
      );

    this.patientservice
      .getgivertype()
      .subscribe(
        data => {

          this.type = data;
          //this.secondArray = data;
          //this.group= data.userGroupId
          ////////console.log('group ' + this.type.userGroupId);
        }

      );



  }

  addcarepostfun(car: NgForm, sucessda) {

    this.caregive = car.value.careGiverId
    let msgvalue = {
      "PatientSWFId": this.patid.patientSWFId,
      "patientId": this.patid.patientId,
      "ccType": car.value.ccType,
      "careGiverId": car.value.careGiverId
    }
    //////console.log(msgvalue);
    this.patientservice
      .cardets(msgvalue)
      .subscribe(
        data => {
          if (data) {
            this.ffar = "";
            this.patname = [];
            this.resdata = "Healthcare Professional Added Successfully";
            this.selectedDeviceObj = '';
            this.selectedObj = '';
            //this.type = this.secondArray;
            // car.reset()
            this.modalRef = this.modalService.show(sucessda, { class: 'modal-sm', backdrop: 'static' });
            this.userservic.logAudit('getCareGiverUpdate', 0).subscribe(data => { })
            this.movable()
          }
          else {
            //////console.log(data);
            //////console.log(data.ccType);
            //////console.log(data.careGiverId);
            this.ffar = "No Healthcare Professional Assigned";
          }


        }

      );


  }
  reset() {

    this.modalRef.hide()
  }
  backToPatDetails() {
    let patDetails = {
      'patientId': this.patid.patientId,
      'patientSWFId': this.patid.patientSWFId,
      'patstatus': this.patid.patstatus,
      'status': this.patid.status
    }
    window.localStorage['patDetails'] = btoa(JSON.stringify(patDetails))
    this.router.navigate([`/care/patientdetails`])
  }



  onChangeObj(userGroupId) {
    this.ffar = "";

    if (userGroupId) {
      this.patientservice
        .getgivername(userGroupId, this.patid.patientId, this.patid.patientSWFId)
        .subscribe(
          data => {

            this.patname = data;

            //////console.log(data)

          }
        );
    } else {
      this.patname = []
    }

  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
}
